/**
 * Copies contents of a DOM node's contents to clipboard, which is useful for copying tables to Excel.
 * eg, to copy a table's rows and cells, with id "choices_table":
 *  <copy-node-button
 *    tooltip="{{'common.copied' | translate}}"
 *    text="{{'instructor.copy_table' | translate}}"
 *    target-id="choices_table">
 *  </copy-node-button>
 */
angular.module('tgaAdmin').directive('copyNodeButton', [
  '$document',
  '$window',
  function ($document, $window) {
    return {
      restrict: 'E',
      scope: {
        tooltip: '@',
        text: '@',
      },
      link(scope, element, attrs) {
        element.on('click', () => {
          const node = $document[0].getElementById(attrs.targetId);
          const range = $document[0].createRange();
          const select = $window.getSelection();

          range.selectNodeContents(node);
          select.removeAllRanges();
          select.addRange(range);
          $document[0].execCommand('copy');
          select.removeAllRanges();
        });
      },
      template: `
        <button type="button" class="btn btn-warning btn-sm ng-isolate-scope" \
        uib-tooltip="{{tooltip}}" tooltip-placement="top" tooltip-trigger="none">
          <span class="fa fa-copy"></span> {{text}}
        </button>
      `,
    };
  }]);
